import styled from 'styled-components'

export const Container = styled.div`
  /* display: flex; */
  padding: 0;
  border: 0;
  background-color: #f5f5f5;
  width: 100vw;
  height: 100vh;
`

export const ContainerOutlet = styled.div`
  padding: 3rem 4rem;
  display: flex;
  flex-direction: column;
  flex: 1;
`